<template>
    <el-container style="height: 100%;">
        <el-main style="height: 100%;">
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<script>
export default {
    name: 'HomePage',
    
}
</script>





// WEBPACK FOOTER //
// src/components/HomePage.vue